import { render, staticRenderFns } from "./DoctorsListCardSkeleton.vue?vue&type=template&id=25ffa89c"
import script from "./DoctorsListCardSkeleton.vue?vue&type=script&lang=js"
export * from "./DoctorsListCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports